// just now
// 1 second ago
// 2 seconds ago
// …
// 59 seconds ago
// 1 minute ago
// 2 minutes ago
// …
// 59 minutes ago
// 1 hour ago
// 2 hours ago
// …
// 24 hours ago
// 1 day ago
// 2 days ago
// …
// 6 days ago
// 1 week ago
// 2 weeks ago
// …
// 3 weeks ago
// 1 month ago
// 2 months ago
// …
// 11 months ago
// 1 year ago
// 2 years ago
// …
export default [
	{
		formatAs: 'now'
	},
	{
		formatAs: 'second'
	},
	{
		formatAs: 'minute'
	},
	{
		formatAs: 'hour'
	},
	{
		formatAs: 'day'
	},
	{
		formatAs: 'week'
	},
	{
		formatAs: 'month'
	},
	{
		formatAs: 'year'
	}
]